import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogService } from '../../Services/dialog.service';
import { DataService } from '../../Services/data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ResetPasswordComponent } from '../resetPassword/reset-password.component';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterLink, MatProgressSpinnerModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements AfterViewInit {
  loginForm: FormGroup;
  private apiUrl = environment.apiUrl;

   @ViewChild('monitorCanvas', { static: true }) monitorCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('anatomyCanvas', { static: true }) anatomyCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('dentalCanvas', { static: true }) dentalCanvas!: ElementRef<HTMLCanvasElement>;



  displayLogin: boolean = false;
  dashBoardDataComplete: any;
  dashBoardDataInComplete: any;
  inCompleteCount: number = 0; // Initialize with a default value
  inprogressCount: number = 0; 

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder, private http: HttpClient, private dialogService: DialogService, public dataService: DataService, private router: Router, private dialog: MatDialog) {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  navigateToSignup() {
    this.router.navigate(['/signup']);
  }

  reset(){
    this.router.navigate(['/reset']);
  }

  getInProgressTasks() {
    this.dataService.getDataAsList('/tasks/in-progress').subscribe({
      next: (response) => {
        this.dashBoardDataInComplete = response.length;
        this.inprogressCount = this.dashBoardDataInComplete; 
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }

  getCompletedTasks() {
    this.dataService.getDataAsList('/tasks/complete').subscribe({
      next: (response) => {
        this.dashBoardDataComplete = response.length;
        this.inCompleteCount = this.dashBoardDataInComplete;
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }

  fetchTasksAndRoute() {
    if(this.dataService.role == 'doctor'){
      this.router.navigate(['/create-task-demo']);
    }else{
      this.router.navigate(['/dashboard']);
    }
    

    // const completedTasks$ = this.dataService.getDataAsList('/tasks/complete');
    // const inProgressTasks$ = this.dataService.getDataAsList('/tasks/in-progress');

    // completedTasks$.subscribe({
    //   next: (response) => {
    //     this.dashBoardDataComplete = response.length;
    //     this.inCompleteCount = this.dashBoardDataInComplete;
    //     this.dataService.updateProgressBarSubject(false);

    //     inProgressTasks$.subscribe({
    //       next: (response) => {
    //         this.dashBoardDataInComplete = response.length;
    //         this.inprogressCount = this.dashBoardDataInComplete;
    //         this.routeToPageAsPertask();
    //       },
    //       error: (err) => {
    //         this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
    //       }
    //     });
    //   },
    //   error: (err) => {
    //     this.dialogService.handleError(err, 'Failed to get Completed Tasks, Please try again.');
    //   }
    // });
  }

  ngOnInit(): void {
     this.http.get<{ [key: string]: string }>(`${this.apiUrl}/user/secure-images`)
    .subscribe({
      next: images => {
     this.drawLayer(this.monitorCanvas, images['loginComp3_V2.png']);
this.drawLayer(this.anatomyCanvas, images['loginComp2_V2.png']);
this.drawLayer(this.dentalCanvas, images['loginComp1_V2.png']);


      },
    });

    this.detectDevTools();
    if (this.dataService.isLoggedIn()) {
      this.fetchTasksAndRoute();
    }

    this.route.queryParamMap.subscribe(params => {
      if (params.get('user') && sessionStorage.getItem('googleAuthCode')) {
        const { username, password } = this.loginForm.value;
        const headers = new HttpHeaders({ 'X-Digital-Auth': btoa(`${params.get('user')}:${sessionStorage.getItem('googleAuthCode')}`) });

        this.http.post<any>(`${this.apiUrl}/user/login`, null, { headers: headers }).subscribe({
          next: (response) => {
            sessionStorage.removeItem('googleAuthCode');
            this.dataService.saveUserDetails(response);
            this.dataService.updateProgressBarSubject(false);
            if (response.isActive) {
              this.fetchTasksAndRoute();
            } else {
              this.router.navigate(['/user-test']);
            }
          },
          error: (error) => {
            var errMsg = error.status == 401 ? 'Incorrect User Id or Password.' : 'Login Failed, please contact System Admin.';
            this.dialogService.openMessageDialog('Error', errMsg);
          }
        });
      } else {
        this.displayLogin = true;
      }
    });
  }

  loginWithGoogle() {
    const code = Math.random().toString(36).substring(2);
    sessionStorage.setItem('googleAuthCode', code);
    const state = btoa(`${window.location.href}||${code}||${this.apiUrl}`);
    window.location.href = `${this.apiUrl}/user/google?state=${state}`;
  }

  openSignupModal(event: MouseEvent) {
    event.preventDefault();
    this.dialog.open(SignUpComponent);
  }

  onSubmit() {
    this.dataService.updateProgressBarSubject(true);
    if (this.loginForm.valid) {
      const { username, password } = this.loginForm.value;
      const headers = new HttpHeaders({ 'X-Digital-Auth': btoa(`${username}:${password}`) });

      this.http.post<any>(`${this.apiUrl}/user/login`, null, { headers: headers }).subscribe({
        next: (response) => {
          this.dataService.saveUserDetails(response);
          this.dataService.updateProgressBarSubject(false);
          if (response.isActive) {
            this.fetchTasksAndRoute();
          } else {
            this.router.navigate(['/user-test']);
          }
        },
        error: (error) => {
          var errMsg = error.status == 401 ? 'Incorrect User Id or Password.' : 'Login Failed, please contact System Admin.';
          this.dialogService.openMessageDialog('Error', errMsg);
        }
      });
    } else {
      this.dialogService.openMessageDialog('Error', 'User Id or Password is missing.');
    }
  }

  routeToPageAsPertask() {

    if(this.dataService.role == 'designer' || this.dataService.role == 'admin'){
      this.router.navigate(['/dashboard']);
    }else if ((this.inCompleteCount > 0) || (this.inprogressCount > 0)) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/create-task-demo']);
    }
  }
  private lastWidth = window.innerWidth;

@ViewChild('parallaxScene') sceneRef!: ElementRef<HTMLElement>;
  layers!: NodeListOf<HTMLElement>;

  ngAfterViewInit() {
    this.layers = this.sceneRef.nativeElement.querySelectorAll('.layer');
    
    this.onResize(); // set initial position
  }

@HostListener('window:resize')
onResize() {
  const w = window.innerWidth;

  const MIN = 1300;
  const MAX = 2400;

  const clamped = Math.min(Math.max(w, MIN), MAX);
  const progress = (clamped - MIN) / (MAX - MIN); // 0 → 1


  const scale = 0.85 + (0.15 * progress);

  const monitor = document.querySelector<HTMLElement>('.layer-monitor');
  if (monitor) {
    monitor.style.transform = `translate(-50%, -50%) scale(${scale})`;
  }

  // 🔥 Define EXACT start and end positions
  const anatomyStart = 450;      // close to monitor
  const anatomyEnd   = 150;    // far right

  const dentalStart  = -450;      // close to monitor
  const dentalEnd    = -100;   // far left

  const anatomyX = anatomyStart + (anatomyEnd - anatomyStart) * progress;
  const dentalX  = dentalStart  + (dentalEnd  - dentalStart)  * progress;

  const anatomy = document.querySelector<HTMLElement>('.layer-anatomy');
  if (anatomy) {
    anatomy.style.transform = `translateX(${anatomyX}px)`;
  }

  const dental = document.querySelector<HTMLElement>('.layer-dental');
  if (dental) {
    dental.style.transform = `translateX(${dentalX}px)`;
  }
}

  
@HostListener('window:keydown', ['$event'])
handleKeyDown(event: KeyboardEvent) {
  // 1. Block F12
  if (event.key === 'F12') {
    event.preventDefault();
    return;
  }

  if (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J' || event.key === 'C')) {
    event.preventDefault();
    return;
  }

  if (event.ctrlKey && event.key === 'u') {
    event.preventDefault();
    return;
  }
  
  if (event.ctrlKey && event.key === 's') {
    event.preventDefault();
    return;
  }
}

detectDevTools() {
  const devtools = {
    isOpen: false,
    orientation: undefined
  };

  const threshold = 160;
  
  setInterval(() => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      console.clear();
      console.log("%cStop!", "color: red; font-size: 40px; font-weight: bold;");
      console.log("This area is protected. Unauthorized access is logged.");
    }
  }, 1000);
}

drawLayer(canvasRef: ElementRef<HTMLCanvasElement>, base64: string) {
  if (!base64) return;

  const canvas = canvasRef.nativeElement;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const img = new Image();
  img.src = 'data:image/png;base64,' + base64;
  img.onload = () => {
    canvas.width = canvas.clientWidth;
    canvas.height = canvas.clientHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  };
}



drawAllLayersInSingleCanvas(images: { [key: string]: string }) {
  const canvas = this.monitorCanvas.nativeElement;
  const ctx = canvas.getContext('2d');
  const w = window.innerWidth;
  const h = window.innerHeight * 0.5;
  canvas.width = w;
  canvas.height = h;

  const layers = ['loginComp3_V2.png', 'loginComp2_V2.png', 'loginComp1_V2.png'];
  layers.forEach((imgName, index) => {
    const img = new Image();
    img.src = 'data:image/png;base64,' + images[imgName];
    img.onload = () => {
      if (!ctx) return;
      // simple stacking with offsets
      ctx.drawImage(img, index*20, index*20, w*0.8, h*0.8);
    };
  });
}


  
}

